.do{background:var(--palette-white);}